import { Section, Image } from '@tracklib/kit'

import styles from './quotesgridblock.css'

type QuotesGridBlockProps = {
  value: {
    heading: string
    sub_heading: string
    quotes: Array<{
      image: number
      image_attribution: string
      text: string
      name: string
      description: string
    }>
  }
}

const QuotesGridBlock = ({ value: { heading, sub_heading, quotes } }: QuotesGridBlockProps): JSX.Element => (
  <Section extraPad>
    {(heading || sub_heading) && (
      <header className={styles.header}>
        {heading && <h2>{heading}</h2>}
        {sub_heading && <p>{sub_heading}</p>}
      </header>
    )}
    <ul className={styles.grid}>
      {quotes.map(({ image, image_attribution, text, name, description }) => (
        <li className={styles.quote} key={description}>
          <div className={styles.image}>
            <Image image={image} absolute />
            {image_attribution && <span>Photo: {image_attribution}</span>}
          </div>
          <p className={styles.text}>{text}</p>
          <h3 className={styles.name}>{name}</h3>
          <p className={styles.description}>{description}</p>
        </li>
      ))}
    </ul>
  </Section>
)

export default QuotesGridBlock
